module.exports = __webpack_public_path__ + "static/media/composio.999c9e87.svg";